import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=1d5b6bae&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b6bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5b6bae')) {
      api.createRecord('1d5b6bae', component.options)
    } else {
      api.reload('1d5b6bae', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=1d5b6bae&scoped=true&", function () {
      api.rerender('1d5b6bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iKdNSyPAhn4t/JS/comp/Accordion.vue"
export default component.exports